// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3BkDR","vLegacy":"SelectSecondary_vLegacy__gbFnV","error":"SelectSecondary_error__25lD5","disabled":"SelectSecondary_disabled__1vgjk"};